import Vue from 'vue'
import { isPC, Throttle, isMideaConnect, getCookie, getCookieOfToken } from '../utils/utils'
export const tagMixin = {
  data () {
    return {
      page: {
        pageNum: 1,
        pageSize: 12
      },
      tagType: 1,
      articleList: [],
      id: '',
      keywords: '',
      keyword: '',
      base_appkey: '',
      errorStatus: false,
      listNumber: 0,
      noImg: 'this.src="' + require('@/assets/images/no-img.png') + '"'
    }
  },
  filters: {
    showWeekday (input) {
      if (!input) {
        return input
      } else {
        const date = new Date(input)
        return date.getMonth() + 1 + '-' + date.getDate()
      }
    }
  },
  methods: {
    getArticleDetail (item) {
      this.$router.push({
        name: 'content_preview',
        query: { defaultHeader: '1' },
        params: { id: item.id }
      })
    },
    loadArticleList () {
      this.loadMoreArticleList()
    },
    loadMoreArticleList: Throttle(function () {
      if (Math.ceil(this.listNumber / 12) > this.page.pageNum) {
        ++this.page.pageNum
        this.getData()
      }
    }),
    validateParams () {
      // 查看文章。只有浏览器含有mideaconnect标识才可以实名评论。否则通通当游客身份处理。
      this.id = this.$route.params.id
      this.keywords = this.$route.params.keywords
      this.keyword = decodeURIComponent(this.$route.params.keywords)
      this.base_appkey = this.$route.params.appKeys
      if (typeof this.id === 'undefined' || typeof this.keywords === 'undefined') {
        this.$toastMessage({ icon: '&#xe69f;', message1: this.$t('lang.notEnoughParam') })
        this.errorStatus = true
        return true
      }
      return true
    },
    getData () {
      const id = this.$route.params.id
      const keywords = this.$route.params.keywords
      console.log(id)
      console.log(keywords)
      this.$store.dispatch('getmaterialListByTag', {
        tagId: this.id,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNum,
        locale: 'zh_CN'
      }).then(data => {
        if (data.data && data.data.data) {
          if (this.articleList.length === 0) {
            this.articleList = data.data.data.list || []
            this.listNumber = data.data.data.total
          } else {
            this.articleList = this.articleList.concat(data.data.data.list)
          }
        }
      })
      this.$store.dispatch('setShowLoadingPic', { showLoadingPic: false })
    }
  },
  created () {
    if (this.validateParams()) {
      const result = {
        data: {
          // eslint-disable-next-line no-undef
          baseUrl: CONFIG.baseUrl
        }
      }
      Vue.prototype.$baseUrl = result.data.baseUrl
      this.getData()
    }
    if (!isPC() && isMideaConnect()) {
      if (!sessionStorage.getItem('token')) {
        sessionStorage.setItem('token', getCookieOfToken('token'))
      }
      if (!sessionStorage.getItem('appkey')) {
        sessionStorage.setItem('appkey', getCookie('appkey'))
      }
      if (!sessionStorage.getItem('username')) {
        sessionStorage.setItem('username', getCookie('username'))
      }
    }
  }
}
